import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  tabs: {
    backgroundColor: "#F2F2F2",
    borderRadius: theme.spacing(1),
  },
  tab: {
    color: "black",
    width: theme.spacing(32),
    height: theme.spacing(4),
    "&.Mui-selected": {
      backgroundColor: "black",
      color: "white",
      borderRadius: "8px",
    },
  },
  athleteMessage: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1),
    cursor: "pointer",
    border: "1px solid #C2C2C2",
    borderRadius: "8px",
    "&:hover": { backgroundColor: "#f5f5f5" },
  },

  messageIcon: {
    // bgcolor: selectedMessage.color,
    width: 40,
    height: 40,
  },
  iconContainer: {
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    background: "#6FA088",
    borderRadius: theme.spacing(1),
    width: theme.spacing(6),
    height: theme.spacing(6),
  },
  planButton: {
    borderRadius: theme.spacing(1),
    color: "black",
    border: `1px solid #000`,
  },
}));

export default useStyles;
